var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "picker",
    staticClass: "Polaris-ColorPicker__HuePicker"
  }, [_c('polaris-color-picker-slidable', {
    attrs: {
      "dragger-y": _vm.offset,
      "dragger-x": 0
    },
    on: {
      "change": _vm.handleChange,
      "draggerheight": _vm.handleDraggerHeight
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-344db098", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344db098","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisColorPickerHuePicker.vue
// module id = 263
// module chunks = 0